export const hasValue = (value: string | number): boolean => !!value;

export const isEmail = (value: string | number): boolean => {
    const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    return re.test(String(value).toLowerCase());
};

export const isNumber = (value: string | number): boolean => /^[^a-zA-Z]*$/g.test(String(value));

export const VALIDATION_TEST = {
    hasValue: (value: string | number) => hasValue(value),
    isEmail: (value: string | number) => isEmail(value),
    isNumber: (value: string | number) => isNumber(value),
};
